import { createAsyncThunk, createSlice, isAsyncThunkAction,PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import fetchAPI from '../../../common/fetchAPI'
import { CurrencyExchangeRateStateClass } from "./interfaces/CurrencyExchangeRateStateClass";
import { sortData } from "../../../common/timeLiveFunction";

const initialState: CurrencyExchangeRateStateClass = {
    isLoading: false,
    CurrencyExchangeRateList: [],
    status: "idle",
    selectedRecord: {},
    isReload: false,
    sortOrder: 'asc',
    sortColumn: 'ExchangeRate',
    search: '',
    pageNo: 1,
    pageSize: 10
};

interface IThunkApi {
    state: {
        currencyExchangeRate: CurrencyExchangeRateStateClass
    }
};

export const getAccountCurrencyExchangeRateAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        "CurrencyExchangeRate/v2/getAccountCurrencyExchangeRate",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/V2/CurrencyExchangeRates", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = await response.json();
            return json;
        }

    )
export const getAccountCurrencyExchangeRateByCurrencyExchangeRateIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "CurrencyExchangeRate/v2/getAccountCurrencyExchangeRateByCurrencyExchangeRateId",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/CurrencyExchangeRates/' + arg, 'GET', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )
export const GetAccountCurrencyExchangeRatesByAccountIdAndAccountCurrencyIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "CurrencyExchangeRate/v2/GetAccountCurrencyExchangeRatesByAccountIdAndAccountCurrencyId",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/CurrencyExchangeRates/GetDataByAccountCurrencyId/' + arg, 'GET', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )

export const addAccountCurrencyExchangeRateAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'CurrencyExchangeRate/v2/addAccountCurrencyExchangeRate',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/CurrencyExchangeRates/', 'POST', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )

export const updateAccountCurrencyExchangeRateAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'CurrencyExchangeRate/v2/updateAccountCurrencyExchangeRate',
        async (arg, thunkApi) => {
            const { AccountCurrencyExchangeRateId, IsUpdateExpenseEntry, ...argWithoutId } = arg;
            const response = await fetchAPI('api/V2/CurrencyExchangeRates/' + AccountCurrencyExchangeRateId + '/' + (IsUpdateExpenseEntry === undefined || IsUpdateExpenseEntry === false ? false : true), 'PUT', argWithoutId, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )
export const deleteAccountCurrencyExchangeRateAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "CurrencyExchangeRate/v2/deleteAccountCurrencyExchangeRate",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/CurrencyExchangeRates/DeleteCurrencyExchangeRate/' + arg, 'Delete', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;

        }
    )
    export const DeleteSelectedAccountCurrencyExchangeRateAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "CurrencyExchangeRate/v2/DeleteSelectedAccountCurrencyExchangeRate",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/CurrencyExchangeRates/DeleteSelected/', 'Delete', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;

        }
    )
export const currencyExchangeRateSlice = createSlice({
    name: "currencyExchangeRate",
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {}
        },
        checkedState: (state, action) => {
            const currentindex = state.CurrencyExchangeRateList.findIndex((item) => item.AccountCurrencyExchangeRateId == action.payload);
            const newArray = [...state.CurrencyExchangeRateList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
            state.CurrencyExchangeRateList = newArray;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.CurrencyExchangeRateList.findIndex((item) => item.AccountCurrencyExchangeRateId == action.payload);
            const newArray = [...state.CurrencyExchangeRateList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.CurrencyExchangeRateList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.CurrencyExchangeRateList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.CurrencyExchangeRateList = newArray;
        },
        unCheckedAllState: (state) => {
            const newArray = state.CurrencyExchangeRateList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.CurrencyExchangeRateList = newArray;
        },
        checkAllCheckboxIsUncheckedState: (state) => {
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateSorting: (state, action) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            let tempArray = state.CurrencyExchangeRateList;
            state.CurrencyExchangeRateList = sortData(tempArray, action.payload.sortOrder, action.payload.sortColumn);
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAccountCurrencyExchangeRateAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getAccountCurrencyExchangeRateAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.CurrencyExchangeRateList = payload.Data;
                state.isReload = false;
                state.isLoading = false;
                state.selectedRecord = {};
            })
            .addCase(getAccountCurrencyExchangeRateAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })

            .addCase(getAccountCurrencyExchangeRateByCurrencyExchangeRateIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getAccountCurrencyExchangeRateByCurrencyExchangeRateIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                if (Object.keys(payload.Data).length === 0) {
                    state.selectedRecord = {};
                }
                else {
                    state.selectedRecord = payload.Data[0];
                }
                state.isLoading = false;
            })
            .addCase(getAccountCurrencyExchangeRateByCurrencyExchangeRateIdAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })


            .addCase(GetAccountCurrencyExchangeRatesByAccountIdAndAccountCurrencyIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(GetAccountCurrencyExchangeRatesByAccountIdAndAccountCurrencyIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                if (Object.keys(payload.Data).length === 0) {
                    state.CurrencyExchangeRateList = [];
                }
                else {
                    state.CurrencyExchangeRateList = payload.Data;
                    state.CurrencyExchangeRateList.map((item: any) => {
                        item.isSelected = 0
                    });
                }
                state.isReload = false;
                state.selectedRecord = {};
                state.isLoading = false;
            })
            .addCase(GetAccountCurrencyExchangeRatesByAccountIdAndAccountCurrencyIdAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })


            .addCase(addAccountCurrencyExchangeRateAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(addAccountCurrencyExchangeRateAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(addAccountCurrencyExchangeRateAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })

            .addCase(updateAccountCurrencyExchangeRateAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(updateAccountCurrencyExchangeRateAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(updateAccountCurrencyExchangeRateAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })

            .addCase(deleteAccountCurrencyExchangeRateAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(deleteAccountCurrencyExchangeRateAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(deleteAccountCurrencyExchangeRateAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })

            .addCase(DeleteSelectedAccountCurrencyExchangeRateAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(DeleteSelectedAccountCurrencyExchangeRateAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(DeleteSelectedAccountCurrencyExchangeRateAsync.rejected, (state) => {
                state.status = 'failed';
            })

    }
});

export const { resetSelectedRecordObjectInState, checkedState, unCheckedState, checkedAllState, unCheckedAllState, checkAllCheckboxIsUncheckedState,updatePagination,updateSorting } = currencyExchangeRateSlice.actions
export const currencyExchangeRateState = (state: RootState) => state.currencyExchangeRate
export default currencyExchangeRateSlice.reducer


